import types from 'actions/types'
import {combineReducers} from 'redux'
import {get} from 'lodash'

const open = (state = false, action) => {
  switch (action.type) {
    case types.PURCHASING_SHOW_ITEM_DRAWER: return true
    case types.PURCHASING_HIDE_ITEM_DRAWER: return false
    case types.PURCHASING_PURCHASE_ORDER_ADD_ORDER_ITEM: return state && !action.closeDrawer
    case types.PURCHASING_LOAD_PURCHASE_ORDER_ATTEMPT: return false
    default: return state
  }
}

const purchaseOrderItem = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_SHOW_ITEM_DRAWER: return action.purchaseOrderItem
    case types.PURCHASING_HIDE_ITEM_DRAWER: return null
    default: return state
  }
}

const part = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_SHOW_ITEM_DRAWER: return action.part || get(action, 'purchaseOrderItem.part', null)
    case types.PURCHASING_HIDE_ITEM_DRAWER: return null
    default: return state
  }
}

const index = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_SHOW_ITEM_DRAWER: return action.index
    case types.PURCHASING_HIDE_ITEM_DRAWER: return null
    default: return state
  }
}

const defaults = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_SHOW_ITEM_DRAWER: return action.defaults
    default: return state
  }
}

const isSaving = (state = false, action) => {
  switch (action.type) {
    case types.PURCHASING_PURCHASE_ORDER_ADD_ORDER_ITEM:
    case types.PURCHASING_PURCHASE_ORDER_EDIT_ORDER_ITEM:
      return true
    case types.PURCHASING_PURCHASE_ORDER_SAVE_SUCCESS:
      return false
    default: return state
  }
}

export default combineReducers({
  open,
  purchaseOrderItem,
  part,
  index,
  defaults,
  isSaving,
})
